(function () {
  var root = document.getElementById('kn-ebooks');
  if (!root || root.dataset.knebInit === '1') return;
  root.dataset.knebInit = '1';

  var scroller = root.querySelector('[data-kneb-scroll]');
  var progFill = root.querySelector('[data-kneb-prog]');
  var backBtn  = root.querySelector('[data-kneb-back]');
  var barTtl   = root.querySelector('[data-kneb-barttl]');
  var libView  = root.querySelector('[data-kneb-view="library"]');
  var readView = root.querySelector('[data-kneb-view="reader"]');
  /* ── lazy book hydration ─────────────────────────────────────────────────────
     The ~160 e-books are stored as raw text in script[type="text/html"][data-kneb-books]
     so the page never parses them into DOM on load. We parse that string ONCE, on demand
     (first book open, or an idle prefetch when the overlay opens), into an inert fragment,
     then clone+cache a book into the live reader the first time it is opened. `books`
     therefore only ever holds books that have actually been opened — exactly what the
     hide-all loops want. */
  var booksSrc  = root.querySelector('[data-kneb-books]'); /* the raw-text book store (or a parsed-node fallback) */
  var booksFrag = null;       /* DocumentFragment parsed once from booksSrc */
  var books     = [];
  var bookCache = {};
  function ensureBooksParsed() {
    if (booksFrag) return booksFrag;
    if (!booksSrc) return null;
    if (booksSrc.content) { booksFrag = booksSrc.content; return booksFrag; } /* <template> fallback */
    var html = booksSrc.textContent || booksSrc.innerHTML || '';
    if (!html) return null;
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    booksFrag = tpl.content;
    return booksFrag;
  }
  function getBook(id) {
    if (bookCache[id]) return bookCache[id];
    var frag = ensureBooksParsed();
    var src = frag ? frag.querySelector('[data-kneb-book="' + id + '"]') : null;
    /* last-ditch fallback: already-hydrated markup live in the overlay */
    if (!src) {
      var live = root.querySelector('[data-kneb-book="' + id + '"]');
      if (live) { bookCache[id] = live; if (books.indexOf(live) < 0) books.push(live); }
      return live || null;
    }
    var node = src.cloneNode(true);
    readView.appendChild(node);
    bookCache[id] = node;
    books.push(node);
    return node;
  }
  var view = 'library';
  var libScroll = 0; /* remembers where you were in the overview so we can return there */

  /* topic-first browsing: overview = one card per topic → tap → topic detail with the
     levels (Beginner/Gevorderd/Hardcore) → pick a level to open the book. */
  var TOPICS = {};        /* key → {title, ttlHTML, coverBg, group, catLabel, levels:[{id,lvl,lvlLabel,tag}]} */
  var currentTopic = null;
  var topicView = document.createElement('div');
  topicView.className = 'kneb__view';
  topicView.setAttribute('data-kneb-view', 'topic');
  topicView.hidden = true;
  if (libView && libView.parentNode) libView.parentNode.insertBefore(topicView, libView.nextSibling);

  /* chapter nav + jargon tooltip refs */
  var navWrap   = root.querySelector('[data-kneb-nav]');
  var navToggle = root.querySelector('[data-kneb-navtoggle]');
  var navList   = root.querySelector('[data-kneb-navlist]');
  var navScrim  = root.querySelector('[data-kneb-navscrim]');
  var tip       = root.querySelector('[data-kneb-tip]');
  var tipTerm   = root.querySelector('[data-kneb-tip-term]');
  var tipDef    = root.querySelector('[data-kneb-tip-def]');
  var tipBtn    = null;          /* the .kneb-term currently showing a tooltip */
  var navTargets = [];           /* [{el, btn}] for scroll-spy in the open book */
  var navRaf = 0;

  /* ── jargon glossary ── one source of truth; terms are auto-linked in any book,
     regardless of level. Each entry: key → {label, def}. The matcher below wraps
     the FIRST mention of each term per book in a tappable .kneb-term button. */
  var GLOSS = {
    rep:      { label:'Rep', def:'Repetition oftewel herhaling: één volledige uitvoering van een oefening, van begin- naar eindstand en terug.' },
    set:      { label:'Set', def:'Een groepje herhalingen achter elkaar, gevolgd door rust. "3 sets van 10" = drie keer tien herhalingen.' },
    rir:      { label:'RIR', def:'Reps In Reserve: hoeveel nette herhalingen je aan het eind van een set nog in de tank had. RIR 2 = je had er nog 2 gekund.' },
    rpe:      { label:'RPE', def:'Rate of Perceived Exertion: hoe zwaar een set voelt op een schaal van 1 tot 10. RPE 8 ≈ 2 herhalingen over (RIR 2).' },
    onerm:    { label:'1RM', def:'One-Rep Max: het zwaarste gewicht dat je met goede techniek precies één keer kunt tillen. De basis voor percentages in een schema.' },
    amrap:    { label:'AMRAP', def:'As Many Reps As Possible: doe zoveel mogelijk nette herhalingen tot net vóór je techniek breekt.' },
    emom:     { label:'EMOM', def:'Every Minute On the Minute: start elke minuut een vaste set; wat van die minuut overblijft is rust.' },
    pr:       { label:'PR', def:'Personal Record: je beste prestatie tot nu toe op een oefening, in gewicht, herhalingen of tijd.' },
    tut:      { label:'TUT', def:'Time Under Tension: hoelang je spier tijdens een set onder spanning staat. Rustiger tempo = meer TUT.' },
    rom:      { label:'ROM', def:'Range Of Motion: de bewegingsuitslag van een oefening. Volledige ROM = van volledige rek tot volledige samentrekking.' },
    hiit:     { label:'HIIT', def:'High-Intensity Interval Training: korte, intense inspanningen afgewisseld met momenten van rust.' },
    tempo:    { label:'Tempo', def:'Het ritme van een herhaling in seconden, bijv. 3-1-1: 3 sec zakken, 1 sec pauze onderin, 1 sec omhoog.' },
    dropset:  { label:'Dropset', def:'Direct na het bereiken van falen verlaag je het gewicht en ga je zonder rust door, voor een extra spierprikkel.' },
    superset: { label:'Superset', def:'Twee oefeningen direct achter elkaar uitgevoerd, zonder rust ertussen.' },
    deload:   { label:'Deload', def:'Een bewust lichtere week met minder volume of intensiteit, zodat je lichaam herstelt en sterker terugkomt.' },
    overload: { label:'Progressive overload', def:'Telkens een beetje meer doen (gewicht, herhalingen of sets) zodat je spieren een reden houden om te groeien.' },
    hypertrofie:{ label:'Hypertrofie', def:'Het groter worden van spierweefsel: het doel van de meeste krachttraining gericht op spiermassa.' },
    failure:  { label:'Falen', def:'Het punt waarop je geen technisch nette herhaling meer kunt maken. "Tot falen" betekent doorgaan tot precies dat punt.' },
    compound: { label:'Compound', def:'Een oefening over meerdere gewrichten die meerdere spiergroepen tegelijk traint, zoals squat, deadlift of bench press.' },
    isolatie: { label:'Isolatie', def:'Een oefening die één spier(groep) over één gewricht traint, zoals een biceps curl of leg extension.' },
    feeder:   { label:'Feeder sets', def:'Lichte, hoge-rep sets die extra bloed en pomp naar de spier brengen zonder je veel te belasten.' },
    macro:    { label:"Macro's", def:'De drie voedingsstoffen die energie leveren: eiwitten, koolhydraten en vetten. Samen bepalen ze je calorie-inname.' },
    kcal:     { label:'Kcal', def:'Kilocalorie: de eenheid voor energie uit voeding. Of je aankomt of afvalt hangt af van je kcal-balans.' }
  };
  /* each src: a word-boundaried alternative with NO inner capturing groups (only (?:…)).
     Order matters: longer/multiword terms first so they win over their substrings. */
  var TERMS = [
    ['overload', "\\b(?:progressive|progressieve)\\s+overload\\b"],
    ['hypertrofie',"\\bhypertrofie\\b"],
    ['superset', "\\bsupersets?\\b"],
    ['dropset',  "\\bdropsets?\\b"],
    ['deload',   "\\bdeloads?\\b"],
    ['feeder',   "\\bfe(?:e)?ders?(?:\\s+sets?)?\\b"],
    ['compound', "\\bcompound(?:s|oefeningen?)?\\b"],
    ['isolatie', "\\bisolati(?:e|on)\\b"],
    ['amrap',    "\\bAMRAP\\b"],
    ['emom',     "\\bEMOM\\b"],
    ['hiit',     "\\bHIIT\\b"],
    ['onerm',    "\\b1RM\\b"],
    ['rir',      "\\bRIR\\b"],
    ['rpe',      "\\bRPE\\b"],
    ['tut',      "\\bTUT\\b"],
    ['rom',      "\\bROM\\b"],
    ['pr',       "\\bPR\\b"],
    ['tempo',    "\\btempo\\b"],
    ['failure',  "\\bfalen\\b"],
    ['macro',    "\\bmacro(?:'s|s)?\\b"],
    ['kcal',     "\\bkcal\\b"],
    ['reps',     "\\breps?\\b"],
    ['sets',     "\\bsets?\\b"]
  ];
  var TERM_KEYS = TERMS.map(function(t){ return t[0]; });
  var TERM_RE = new RegExp(TERMS.map(function(t){ return '(' + t[1] + ')'; }).join('|'), 'gi');

  function lock()   { document.body.classList.add('kneb-lock'); }
  function unlock() { document.body.classList.remove('kneb-lock'); }

  function openOverlay() {
    root.style.display = 'flex';
    root.offsetHeight;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    lock();
    showLibrary();
    /* warm the heavy book store in the background so the first book open is instant */
    if (window.requestIdleCallback) requestIdleCallback(function(){ ensureBooksParsed(); }, { timeout: 3000 });
    else setTimeout(function(){ ensureBooksParsed(); }, 600);
  }
  function closeOverlay() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    unlock();
    libScroll = 0;                              /* next open starts at the top of the overview */
    if (root._knebResetFilters) root._knebResetFilters(); /* clear stale search/filter on reopen */
    setTimeout(function () { if (!root.classList.contains('is-open')) root.style.display = 'none'; }, 240);
  }
  function showLibrary() {
    view = 'library';
    closeTip(); closeNav();
    if (navWrap)  navWrap.hidden = true;
    navTargets = [];
    if (readView) readView.hidden = true;
    if (topicView) topicView.hidden = true;
    if (libView)  libView.hidden = false;
    books.forEach(function (b) { b.hidden = true; });
    if (backBtn) backBtn.hidden = true;
    if (barTtl)  barTtl.textContent = 'Gratis e-books';
    setProgress(0);
    /* land back on the e-book you just had open, not at the top */
    if (scroller) scroller.scrollTop = libScroll;
  }
  function showBook(id) {
    var target = getBook(id);
    if (!target) return;
    books.forEach(function (b) { b.hidden = (b !== target); });
    view = 'reader';
    closeTip(); closeNav();
    if (libView)  libView.hidden = true;
    if (topicView) topicView.hidden = true;
    if (readView) readView.hidden = false;
    if (backBtn) backBtn.hidden = true; /* the floating hamburger is the left control now */
    if (barTtl)  barTtl.textContent = target.getAttribute('data-kneb-title') || 'E-book';
    if (scroller) scroller.scrollTop = 0;
    setProgress(0);
    decorateTerms(target);  /* auto-link jargon (once per book) */
    buildNav(target);       /* (re)build the chapter list */
    if (navWrap) navWrap.hidden = false;
  }
  var WHOFOR = {
    beginner:  'Rustige opbouw, focus op techniek.',
    gevorderd: 'Meer volume en intensiteit.',
    hardcore:  'Maximaal volume, hoge intensiteit.',
    iedereen:  'Voor elk niveau.'
  };
  function showTopic(key) {
    var t = TOPICS[key]; if (!t) return;
    if (view === 'library' && scroller) libScroll = scroller.scrollTop; /* remember overview position */
    currentTopic = key;
    view = 'topic';
    closeTip(); closeNav();
    if (navWrap) navWrap.hidden = true;
    navTargets = [];
    if (libView)  libView.hidden = true;
    if (readView) readView.hidden = true;
    books.forEach(function (b) { b.hidden = true; });
    var rows = t.levels.map(function (l, i) {
      var whofor = WHOFOR[l.lvl] || 'Gratis e-book.';
      var meta = l.tag ? '<span class="kneb-level__meta">' + l.tag + '</span>' : '';
      var no = ('0' + (i + 1)).slice(-2);
      return '<button type="button" class="kneb-level kneb-level--' + l.lvl + '" data-kneb-open="' + l.id + '" aria-label="' + l.lvlLabel + ' — ' + t.title + '">'
        + '<span class="kneb-level__no" aria-hidden="true">' + no + '</span>'
        + '<span class="kneb-level__main"><span class="kneb-level__name">' + l.lvlLabel + '</span>'
        + '<span class="kneb-level__desc">' + whofor + '</span>' + meta + '</span>'
        + '<span class="kneb-level__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></span>'
        + '</button>';
    }).join('');
    topicView.innerHTML =
      '<div class="kneb-topic">'
      + '<div class="kneb-topic__hero"><div class="kneb-topic__heroin">'
      +   '<span class="kneb-topic__eyebrow">' + t.catLabel + '</span>'
      +   '<h2 class="kneb-topic__title">' + t.ttlHTML + '</h2>'
      + '</div></div>'
      + '<div class="kneb-topic__body">'
      +   '<p class="kneb-topic__intro">Kies de zwaarte die bij je past.</p>'
      +   '<div class="kneb-topic__levels">' + rows + '</div>'
      +   '<button type="button" class="kneb-topic__back" data-kneb-back><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>Alle e-books</button>'
      + '</div></div>';
    var hero = topicView.querySelector('.kneb-topic__hero');
    if (hero && t.coverBg) hero.style.backgroundImage = t.coverBg;
    topicView.hidden = false;
    if (backBtn) backBtn.hidden = false;
    if (barTtl)  barTtl.textContent = t.title;
    setProgress(0);
    if (scroller) scroller.scrollTop = 0;
  }
  function setProgress(pct) { if (progFill) progFill.style.width = Math.max(0, Math.min(100, pct)) + '%'; }

  /* ── chapter navigation (floating hamburger → morphing panel) ───────────────── */
  function openNav(){
    if (!navWrap) return;
    navWrap.classList.add('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'true');
    if (navScrim){ navScrim.hidden = false; requestAnimationFrame(function(){ navScrim.classList.add('is-open'); }); }
    var its = navList ? navList.querySelectorAll('.kneb-nav__item') : [];
    Array.prototype.forEach.call(its, function(b, i){ b.style.setProperty('--d', (i * 22) + 'ms'); });
    var act = navList && navList.querySelector('.kneb-nav__item.is-active');
    if (act && act.scrollIntoView){ try { act.scrollIntoView({ block: 'nearest' }); } catch (e){} }
  }
  function closeNav(){
    if (!navWrap) return;
    navWrap.classList.remove('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    if (navScrim){ navScrim.classList.remove('is-open'); setTimeout(function(){ if (!navWrap.classList.contains('is-open')) navScrim.hidden = true; }, 280); }
  }
  function toggleNav(){ if (navWrap && navWrap.classList.contains('is-open')) closeNav(); else openNav(); }

  function mkNavItem(gotoId, label, ix, isDay, tag){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kneb-nav__item' + (isDay ? ' kneb-nav__item--plan' : '');
    btn.setAttribute('data-kneb-goto', gotoId);
    var html = '';
    if (isDay) html += '<span class="kneb-nav__ix">' + (ix || '') + '</span>';
    html += '<span class="kneb-nav__lbl"></span>';
    if (isDay) html += '<span class="kneb-nav__plan-tag">' + (tag || 'Plan') + '</span>';
    btn.innerHTML = html;
    btn.querySelector('.kneb-nav__lbl').textContent = label;
    return btn;
  }
  function buildNav(target){
    if (!navList) return;
    navList.innerHTML = '';
    navTargets = [];
    var frag = document.createDocumentFragment();
    var cover = target.querySelector('.kneb-cover');
    if (cover){
      var b0 = mkNavItem('__top', 'Begin', null, false);
      navTargets.push({ el: target, btn: b0 });
      frag.appendChild(b0);
    }
    var secs = Array.prototype.slice.call(target.querySelectorAll('.kneb-ch, .kneb-day'));
    secs.forEach(function(sec, i){
      if (!sec.id) sec.id = (target.getAttribute('data-kneb-book') || 'kneb') + '-sec-' + i;
      var isDay = sec.classList.contains('kneb-day');
      var label, ix = null, tag = null;
      if (isDay){
        var t = sec.querySelector('.kneb-day__title');
        var n = sec.querySelector('.kneb-day__n');
        var nTxt = (n && n.textContent) || '';
        label = ((t && t.textContent) || 'Schema').trim();
        var dm = nTxt.match(/\d+/);
        ix = dm ? dm[0] : '';
        tag = /^\s*les\b/i.test(nTxt) ? 'Les' : 'Plan'; /* skill-book lessons vs training schema */
      } else {
        var h = sec.querySelector('.kneb-h2');
        label = ((h && h.textContent) || 'Hoofdstuk').trim();
      }
      var btn = mkNavItem(sec.id, label, ix, isDay, tag);
      navTargets.push({ el: sec, btn: btn });
      frag.appendChild(btn);
    });
    navList.appendChild(frag);
    updateNavActive();
  }
  function gotoSection(id){
    if (!scroller) return;
    if (id === '__top'){ scroller.scrollTo ? scroller.scrollTo({ top: 0, behavior: 'smooth' }) : (scroller.scrollTop = 0); return; }
    var el = document.getElementById(id);
    if (!el) return;
    var top = scroller.scrollTop + (el.getBoundingClientRect().top - scroller.getBoundingClientRect().top) - 8;
    top = Math.max(0, top);
    if (scroller.scrollTo) scroller.scrollTo({ top: top, behavior: 'smooth' }); else scroller.scrollTop = top;
  }
  function updateNavActive(){
    if (!navTargets.length || !scroller) return;
    var ref = scroller.getBoundingClientRect().top + 96;
    var activeIdx = 0;
    for (var i = 0; i < navTargets.length; i++){
      if (navTargets[i].el.getBoundingClientRect().top - ref <= 0) activeIdx = i; else break;
    }
    for (var j = 0; j < navTargets.length; j++){ navTargets[j].btn.classList.toggle('is-active', j === activeIdx); }
  }

  /* ── jargon auto-linking + tappable tooltip ─────────────────────────────────── */
  var TERM_SKIP = 'code, h1, h2, h3, h4, button, a, .kneb-term, .kneb-cover, .kneb-kicker, .kneb-day__n, .kneb-day__title, .kneb-gate';
  function splitTerms(text, found){
    TERM_RE.lastIndex = 0;
    var out = [], last = 0, wrapped = 0, m;
    while ((m = TERM_RE.exec(text))){
      var gi = -1;
      for (var i = 1; i < m.length; i++){ if (m[i] != null){ gi = i; break; } }
      if (gi < 0) continue;
      var key = TERM_KEYS[gi - 1];
      if (found[key] || !GLOSS[key]) continue; /* only first mention per book */
      found[key] = true; wrapped++;
      if (m.index > last) out.push({ t: text.slice(last, m.index) });
      out.push({ k: key, t: m[0] });
      last = m.index + m[0].length;
    }
    if (!wrapped) return null;
    if (last < text.length) out.push({ t: text.slice(last) });
    return out;
  }
  function decorateTerms(target){
    if (!target || target._knTerms) return;
    target._knTerms = true;
    var body = target.querySelector('.kneb-body') || target;
    var found = {};
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [], node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function(n){
      var txt = n.nodeValue;
      if (!txt || !/\S/.test(txt)) return;
      var parent = n.parentNode;
      if (!parent || (parent.closest && parent.closest(TERM_SKIP))) return;
      var segs = splitTerms(txt, found);
      if (!segs) return;
      var frag = document.createDocumentFragment();
      segs.forEach(function(s){
        if (s.k){
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kneb-term';
          btn.setAttribute('data-kn-term', s.k);
          btn.setAttribute('aria-label', 'Wat betekent ' + (GLOSS[s.k] ? GLOSS[s.k].label : s.t) + '?');
          btn.textContent = s.t;
          frag.appendChild(btn);
        } else {
          frag.appendChild(document.createTextNode(s.t));
        }
      });
      parent.replaceChild(frag, n);
    });
  }
  function openTip(btn){
    var key = btn.getAttribute('data-kn-term'); var g = GLOSS[key];
    if (!g || !tip) return;
    if (tipBtn === btn && tip.classList.contains('is-open')){ closeTip(); return; }
    closeTip();
    if (tipTerm) tipTerm.textContent = g.label;
    if (tipDef)  tipDef.textContent  = g.def;
    tip.hidden = false;
    tip.style.left = '0px'; tip.style.top = '-9999px';
    tip.classList.add('is-open');
    var rootR = root.getBoundingClientRect();
    var r = btn.getBoundingClientRect();
    var tw = tip.offsetWidth, th = tip.offsetHeight;
    var left = Math.max(8, Math.min(r.left - rootR.left, rootR.width - tw - 8));
    var below = (r.bottom - rootR.top) + 8;
    var above = (r.top - rootR.top) - th - 8;
    var top = (below + th <= rootR.height - 8) ? below : Math.max(8, above);
    tip.style.left = left + 'px';
    tip.style.top  = top + 'px';
    btn.classList.add('is-open');
    tipBtn = btn;
  }
  function closeTip(){
    if (!tip) return;
    tip.classList.remove('is-open');
    if (tipBtn){ tipBtn.classList.remove('is-open'); tipBtn = null; }
    setTimeout(function(){ if (!tip.classList.contains('is-open')) tip.hidden = true; }, 180);
  }

  /* ── library: search + level + grouped categories, sectioned for oversight ──
     One CAT map (id-stem → [label, group]) is the single source of truth: the
     group chips and the library sections are generated from the books actually
     present, so new books auto-slot into the right group with no chip upkeep. */
  (function initFilters(){
    var bar     = root.querySelector('[data-kneb-filters]');
    var host    = root.querySelector('[data-kneb-shelves]');
    var empty   = root.querySelector('[data-kneb-empty]');
    var chipsEl = root.querySelector('[data-kneb-groupchips]');
    var countEl = root.querySelector('[data-kneb-count]');
    var searchEl= root.querySelector('[data-kneb-search]');
    if (!bar || !host) return;

    var CAT = {
      arms:['Armen','spier'], chest:['Borst','spier'], back:['Rug','spier'], legs:['Benen','spier'],
      shoulders:['Schouders','spier'], core:['Core','spier'], fullbody:['Full body','spier'],
      vetverlies:['Vetverlies','doel'], bulken:['Bulken','doel'], droogtrainen:['Droogtrainen','doel'],
      recomp:['Recomp','doel'], sixpack:['Sixpack','doel'], bodybuilding:['Bodybuilding','doel'],
      strongman:['Strongman','doel'], powerlifting:['Powerlifting','doel'], glutes:['Big Booty','doel'],
      sculpting:['Female Sculpting','doel'], conditie:['Conditie & HIIT','doel'],
      blessurepreventie:['Blessurepreventie','doel'], mobiliteit:['Mobiliteit','doel'],
      hardlopen:['Hardlopen','sport'], wielrennen:['Wielrennen','sport'], zwemmen:['Zwemmen','sport'],
      triatlon:['Triatlon','sport'], hyrox:['Hyrox','sport'], boksen:['Boksen','sport'],
      kickboksen:['Kickboksen','sport'], functioneel:['Functioneel','sport'], voetbal:['Voetbal','sport'], hockey:['Hockey','sport'],
      padel:['Padel','sport'], tennis:['Tennis','sport'], volleybal:['Volleybal','sport'],
      basketbal:['Basketbal','sport'], golf:['Golf','sport'], schaatsen:['Schaatsen','sport'],
      klimmen:['Klimmen','sport'], wintersport:['Wintersport','sport'], roeien:['Roeien','sport'],
      thuis:['Thuis','thuis'], calisthenics:['Calisthenics','thuis'], buiten:['Buiten','thuis'],
      hotelgym:['Hotel gym','thuis'], kantoor:['Kantoor','thuis'], ouders:['Drukke ouders','thuis'],
      yoga:['Yoga','mind'], pilates:['Pilates','mind'],
      kettlebell:['Kettlebell','materiaal'], dumbbell:['Dumbbell','materiaal'], banden:['Banden','materiaal'], trx:['TRX','materiaal'],
      senioren:['50+','voorwie'], tieners:['Tieners','voorwie'],
      canva:['Canva','skills'], capcut:['CapCut','skills'],
      supraspinatus:['Supraspinatus','herstel'],
      infraspinatus:['Infraspinatus','herstel'],
      schouderimpingement:['Schouderimpingement','herstel'],
      'frozen-shoulder':['Frozen shoulder','herstel'],
      bicepspees:['Bicepspees','herstel'],
      tenniselleboog:['Tenniselleboog','herstel'],
      golfelleboog:['Golferselleboog','herstel'],
      carpaaltunnel:['Carpaaltunnel','herstel'],
      polspees:['Pols en De Quervain','herstel'],
      'lage-rugpijn':['Lage rugpijn','herstel'],
      hernia:['Lumbale hernia','herstel'],
      ischias:['Ischias','herstel'],
      nekklachten:['Nekklachten','herstel'],
      'si-gewricht':['SI-gewricht','herstel'],
      bekkeninstabiliteit:['Bekkeninstabiliteit','herstel'],
      bekkenbodem:['Bekkenbodem','herstel'],
      heupimpingement:['Heupimpingement','herstel'],
      liesblessure:['Liesblessure','herstel'],
      'bursitis-heup':['Heupbursitis','herstel'],
      patellofemoraal:['Patellofemorale pijn','herstel'],
      'jumpers-knee':['Jumpers knee','herstel'],
      'voorste-kruisband':['Voorste kruisband','herstel'],
      meniscus:['Meniscus','herstel'],
      mcl:['Mediale knieband','herstel'],
      achillespees:['Achillespees','herstel'],
      kuitblessure:['Kuitblessure','herstel'],
      'shin-splints':['Shin splints','herstel'],
      'fasciitis-plantaris':['Hielspoor','herstel'],
      enkelverstuiking:['Enkelverstuiking','herstel'],
      hamstringblessure:['Hamstringblessure','herstel'],
    };
    /* 'overig' is last so any uncategorised book still gets a section (never disappears) */
    var GROUPS = [['spier','Spiergroepen'],['doel','Doelen & fysiek'],['sport','Sporten'],['thuis','Thuis & onderweg'],['mind','Mind & body'],['materiaal','Materiaal'],['voorwie','Voor wie'],['skills','Content & skills'],['herstel','Herstel & revalidatie'],['overig','Overig']];

    function levelOf(id){ if(/-beginner$/.test(id))return'beginner'; if(/-hardcore$/.test(id))return'hardcore'; if(id==='fullbody')return'iedereen'; return 'gevorderd'; }
    function catOf(id){ if(id==='monster-arms')return'arms'; return id.replace(/-(beginner|hardcore)$/,''); }

    var catOrder = {}, ci = 0; for (var k in CAT){ if (CAT.hasOwnProperty(k)){ catOrder[k] = ci++; } }
    var lvlRank = { beginner:0, gevorderd:1, iedereen:1, hardcore:2 };

    /* level is chosen inside a topic now — hide the level filter row */
    var lvlRow = bar.querySelector('[role="group"][aria-label="Filter op niveau"]'); if (lvlRow) lvlRow.hidden = true;

    /* collect the per-level shelves into one entry per topic. The source tiles live
       inert in <template data-kneb-shelves-src> (metadata only, never shown), so read
       from there; fall back to the live host if the template is ever absent. */
    var shelfSrc  = root.querySelector('[data-kneb-shelves-src]');
    var shelfRoot = (shelfSrc && shelfSrc.content) ? shelfSrc.content : host;
    var shelves = Array.prototype.slice.call(shelfRoot.querySelectorAll('.kneb-shelf'));
    var byKey = {}, order = [];
    shelves.forEach(function(s){
      var id = s.getAttribute('data-kneb-open') || '';
      var lvl = levelOf(id), cat = catOf(id);
      var meta = CAT[cat] || ['Overig','overig'];
      var coverEl = s.querySelector('.kneb-shelf__cover');
      var ttlEl   = s.querySelector('.kneb-shelf__on-ttl');
      var descEl  = s.querySelector('.kneb-shelf__desc');
      var badgeEl = s.querySelector('.kneb-shelf__badge');
      var aria = (s.getAttribute('aria-label') || '').replace(/^Open:\s*/, '').replace(/,\s*(Beginner|Gevorderd|Hardcore|Iedereen)\s*$/i, '').trim();
      var t = byKey[cat];
      if (!t){
        t = byKey[cat] = { key:cat, title:(aria || meta[0]), ttlHTML:(ttlEl ? ttlEl.innerHTML : (aria || meta[0])),
          coverBg:(coverEl ? coverEl.style.backgroundImage : ''), group:meta[1], catLabel:meta[0], levels:[], q:'' };
        order.push(cat);
      }
      t.levels.push({ id:id, lvl:lvl, lvlLabel:(badgeEl ? (badgeEl.textContent||'').trim() : lvl),
        tag:(descEl ? (descEl.textContent||'').trim() : ''), rank:(lvlRank[lvl]==null?1:lvlRank[lvl]) });
      t.q += ' ' + (s.textContent || '') + ' ' + meta[0] + ' ' + cat;
    });
    order.forEach(function(k){ var t = byKey[k]; t.levels.sort(function(a,b){ return a.rank - b.rank; }); t.q = t.q.toLowerCase(); });
    TOPICS = byKey;

    function topicCard(t){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kneb-shelf kneb-topiccard';
      var single = t.levels.length === 1;
      if (single) b.setAttribute('data-kneb-open', t.levels[0].id); else b.setAttribute('data-kneb-topic-open', t.key);
      b.setAttribute('aria-label', (single ? 'Open: ' : 'Onderwerp: ') + t.title);
      b._q = t.q; b._group = t.group; b._cat = t.key;
      var niveaus = single ? '1 niveau' : (t.levels.length + ' niveaus');
      b.innerHTML =
        '<span class="kneb-shelf__cover">'
        + '<span class="kneb-shelf__badge kneb-topiccard__count">' + niveaus + '</span>'
        + '<span class="kneb-shelf__open" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>'
        + '<span class="kneb-shelf__on"><span class="kneb-shelf__on-ttl">' + t.ttlHTML + '</span></span>'
        + '</span>'
        + '<span class="kneb-shelf__body"><span class="kneb-shelf__by">door Tufan</span><span class="kneb-shelf__desc">' + niveaus + ' · gratis</span></span>';
      var cov = b.querySelector('.kneb-shelf__cover'); if (cov && t.coverBg) cov.style.backgroundImage = t.coverBg;
      return b;
    }

    /* topic cards, grouped into the same labeled sections */
    var present = {};
    order.forEach(function(k){ var t = byKey[k]; (present[t.group] = present[t.group] || []).push(t); });
    host.innerHTML = '';
    GROUPS.forEach(function(g){
      var list = present[g[0]]; if (!list || !list.length) return;
      list.sort(function(a,b){ return (catOrder[a.key]==null?999:catOrder[a.key]) - (catOrder[b.key]==null?999:catOrder[b.key]); });
      var sec = document.createElement('section'); sec.className = 'kneb-group'; sec.setAttribute('data-group', g[0]);
      var h = document.createElement('h3'); h.className = 'kneb-group__title'; h.innerHTML = g[1] + ' <span class="kneb-group__count" data-gc="'+g[0]+'"></span>';
      var gr = document.createElement('div'); gr.className = 'kneb-group__grid';
      list.forEach(function(t){ gr.appendChild(topicCard(t)); });
      sec.appendChild(h); sec.appendChild(gr); host.appendChild(sec);
    });
    var sections = Array.prototype.slice.call(host.querySelectorAll('.kneb-group'));
    var cards = Array.prototype.slice.call(host.querySelectorAll('.kneb-shelf'));

    /* group chips (Alles + present groups) */
    if (chipsEl){
      var chtml = '<button type="button" class="kneb-chip is-active" data-kneb-filter="group" data-val="all">Alles</button>';
      GROUPS.forEach(function(g){ if (present[g[0]] && present[g[0]].length){ chtml += '<button type="button" class="kneb-chip" data-kneb-filter="group" data-val="'+g[0]+'">'+g[1]+'</button>'; } });
      chipsEl.innerHTML = chtml;
    }

    var state = { group:'all', q:'' };
    function apply(){
      var shown = 0, per = {};
      cards.forEach(function(c){
        var okG = state.group==='all' || c._group===state.group;
        var okQ = !state.q || (c._q||'').indexOf(state.q) >= 0;
        var vis = okG && okQ;
        c.classList.toggle('kneb-shelf--hidden', !vis);
        if (vis){ shown++; per[c._group] = (per[c._group]||0) + 1; }
      });
      sections.forEach(function(sec){ var key = sec.getAttribute('data-group'); sec.classList.toggle('kneb-group--hidden', !(per[key] > 0)); var gc = sec.querySelector('[data-gc]'); if (gc) gc.textContent = per[key] || 0; });
      if (countEl) countEl.textContent = shown + (shown===1 ? ' onderwerp' : ' onderwerpen');
      if (empty) empty.hidden = shown !== 0;
    }

    bar.addEventListener('click', function(e){
      var chip = e.target.closest('[data-kneb-filter]'); if (!chip) return;
      var grp = chip.getAttribute('data-kneb-filter'); state[grp] = chip.getAttribute('data-val');
      var sib = bar.querySelectorAll('[data-kneb-filter="' + grp + '"]');
      Array.prototype.forEach.call(sib, function(c){ c.classList.toggle('is-active', c === chip); });
      apply();
    });
    if (searchEl){ searchEl.addEventListener('input', function(){ state.q = (searchEl.value || '').trim().toLowerCase(); apply(); }); }
    root._knebResetFilters = function(){ if (searchEl) searchEl.value = ''; state.q = ''; state.group = 'all'; if (chipsEl){ Array.prototype.forEach.call(chipsEl.querySelectorAll('[data-kneb-filter="group"]'), function(c){ c.classList.toggle('is-active', c.getAttribute('data-val') === 'all'); }); } apply(); };
    apply();
  })();

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-knebooks-open]');
    if (opener) { e.preventDefault(); openOverlay(); return; }
    if (!root.classList.contains('is-open')) return;
    /* jargon tooltip: a term toggles its own tip; a click anywhere else dismisses it */
    var term = e.target.closest('[data-kn-term]');
    if (term && root.contains(term)) { e.preventDefault(); openTip(term); return; }
    if (tip && tip.classList.contains('is-open') && !e.target.closest('[data-kneb-tip]')) closeTip();
    /* chapter nav */
    if (e.target.closest('[data-kneb-navtoggle]')) { e.preventDefault(); toggleNav(); return; }
    if (e.target.closest('[data-kneb-navscrim]'))  { e.preventDefault(); closeNav(); return; }
    var go = e.target.closest('[data-kneb-goto]');
    if (go && root.contains(go)) { e.preventDefault(); gotoSection(go.getAttribute('data-kneb-goto')); closeNav(); return; }
    var topcard = e.target.closest('[data-kneb-topic-open]');
    if (topcard && root.contains(topcard)) { e.preventDefault(); showTopic(topcard.getAttribute('data-kneb-topic-open')); return; }
    var card = e.target.closest('[data-kneb-open]');
    if (card && root.contains(card)) { e.preventDefault(); showBook(card.getAttribute('data-kneb-open')); return; }
    if (e.target.closest('[data-kneb-back]'))  { e.preventDefault(); showLibrary(); return; }
    if (e.target.closest('[data-kneb-close]')) { e.preventDefault(); if (view === 'reader' || view === 'topic') showLibrary(); else closeOverlay(); return; }
    var dl = e.target.closest('[data-kneb-download]');
    if (dl) {
      var href = (dl.getAttribute('href') || '').trim();
      if (href && href !== '#') return; /* a real hosted PDF is set → let the anchor download it */
      e.preventDefault();
      downloadActiveBook(dl); /* otherwise generate + download a PDF client-side */
      return;
    }
  });

  /* Deep link from the e-mail: ?open=ebooks&book=<key>&download=1 opens that exact
     book and fires its on-device PDF download (the "download je e-book opnieuw"
     button). Plain ?open=ebooks (no book) is handled by the gadgets tile opener. */
  window.addEventListener('load', function () {
    var qp; try { qp = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (qp.get('open') !== 'ebooks') return;
    var key = (qp.get('book') || '').trim();
    if (!key) return;
    setTimeout(function () {
      try { openOverlay(); showBook(key); } catch (e) { return; }
      if (qp.get('download') !== '1') return;
      setTimeout(function () {
        var node = getBook(key);
        var dl = node && node.querySelector('[data-kneb-download]');
        if (!dl) return;
        var href = (dl.getAttribute('href') || '').trim();
        if (href && href !== '#') { window.location.href = href; }
        else { try { downloadActiveBook(dl, true); } catch (e) {} }
      }, 550);
    }, 90);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
    if (tip && tip.classList.contains('is-open')) { closeTip(); return; }
    if (navWrap && navWrap.classList.contains('is-open')) { closeNav(); return; }
    if (view === 'reader') showLibrary(); else closeOverlay();
  });

  if (scroller) {
    scroller.addEventListener('scroll', function () {
      if (view !== 'reader') { setProgress(0); return; }
      var max = scroller.scrollHeight - scroller.clientHeight;
      setProgress(max > 0 ? (scroller.scrollTop / max) * 100 : 0);
      if (tipBtn) closeTip();
      if (navRaf) return;
      navRaf = requestAnimationFrame(function(){ navRaf = 0; updateNavActive(); });
    }, { passive: true });
  }

  /* The email-capture form lives inside lazily-cloned book nodes (one per book),
     so DELEGATE the submit on the overlay root. A direct init-time listener would
     never bind now (books are not in the DOM until opened) — and even before the
     lazy-load it only ever wired the FIRST book's form. */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kneb-mailform]');
    if (!form || !root.contains(form)) return;
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var status = form.querySelector('[data-kneb-mailstatus]');
    var btn = form.querySelector('[data-kneb-mailbtn]');
    var email = (input && input.value || '').trim();
    if (!email || email.indexOf('@') < 1) {
      if (status) { status.hidden = false; status.className = 'kneb-gate__status is-err'; status.textContent = 'Vul een geldig e-mailadres in.'; }
      return;
    }
    var done = function (ok) {
      if (!status) return;
      status.hidden = false;
      status.className = 'kneb-gate__status ' + (ok ? 'is-ok' : 'is-err');
      status.textContent = ok ? 'Top! Check je inbox, je staat op de lijst.' : 'Er ging iets mis. Probeer het later opnieuw.';
      if (ok && btn) { btn.disabled = true; if (input) input.disabled = true; }
    };
    var bk = root.querySelector('.kneb-book:not([hidden])');
    var source = bk ? ('E-book: ' + (bk.getAttribute('data-kneb-title') || '')) : 'E-book';

    /* 1) Metric event → the Klaviyo flow e-mails the e-book link. */
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { '$email': email }]);
      window._learnq.push(['track', 'E-book aangevraagd', { titel: source, boek: (bk && bk.getAttribute('data-kneb-book')) || '' }]);
    } catch (e2) {}

    /* 2) Subscribe to the E-book list + grant marketing consent. Inline (company key + list ID
       straight from theme settings) so it does NOT depend on any shared global being loaded.
       Single opt-in list = consent granted immediately. */
    var KL_CO = window.KNEB_CFG.klCompany;
    var KL_LI = window.KNEB_CFG.klListEbook;
    if (KL_CO && KL_LI) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_CO), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: KL_LI } } } } })
      }).then(function () { done(true); }).catch(function () { done(true); });
    } else {
      done(true);
    }
  });

  /* ── real PDF download ──────────────────────────────────────────────────────
     Built section-by-section so each html2canvas pass stays small (well under
     mobile canvas-size limits — the reason whole-document capture returns blank
     on phones), assembled into a real A4 PDF and handed to the browser as a Blob
     download (works on iOS 13+/Android, no print dialog). 90%+ of traffic is
     mobile, so this path is the one that has to be bullet-proof. */
  var _pdfLibs = null;
  function loadScript(src){
    return new Promise(function(res, rej){
      var s = document.createElement('script'); s.src = src;
      s.onload = function(){ res(true); };
      s.onerror = function(){ rej(new Error('script ' + src)); };
      document.head.appendChild(s);
    });
  }
  function loadPdfLibs(){
    if (_pdfLibs) return _pdfLibs;
    _pdfLibs = (async function(){
      if (!(window.jspdf && window.jspdf.jsPDF)) await loadScript(window.KNEB_CFG.jspdf);
      if (!window.html2canvas)                  await loadScript(window.KNEB_CFG.html2canvas);
      if (!(window.jspdf && window.jspdf.jsPDF) || !window.html2canvas) throw new Error('pdf libs unavailable');
      return { jsPDF: window.jspdf.jsPDF, h2c: window.html2canvas };
    })();
    return _pdfLibs;
  }
  function waitForImages(el){
    var imgs = Array.prototype.slice.call(el.querySelectorAll('img'));
    return Promise.all(imgs.map(function(img){
      if (img.complete && img.naturalWidth) return Promise.resolve();
      return new Promise(function(res){
        var t = setTimeout(res, 4000);
        img.addEventListener('load',  function(){ clearTimeout(t); res(); }, { once: true });
        img.addEventListener('error', function(){ clearTimeout(t); res(); }, { once: true });
      });
    })).then(function(){ return (document.fonts && document.fonts.ready) ? document.fonts.ready.catch(function(){}) : null; });
  }
  function nextFrame(){ return new Promise(function(r){ requestAnimationFrame(function(){ requestAnimationFrame(r); }); }); }

  async function buildBookPdf(book, onProgress){
    var libs = await loadPdfLibs();
    var jsPDF = libs.jsPDF, h2c = libs.h2c;
    var CSSW = 794;
    var isMobile = Math.min(window.innerWidth, window.innerHeight) < 768;
    var SCALE = isMobile ? 1.8 : 2;

    /* off-screen clone, wrapped in .kneb so the scoped fonts/CSS vars apply */
    var holder = document.createElement('div');
    holder.setAttribute('aria-hidden', 'true');
    holder.style.cssText = 'position:fixed;left:-100000px;top:0;width:' + CSSW + 'px;height:auto;background:#fff;z-index:-1;pointer-events:none;';
    var scope = document.createElement('div');
    scope.className = 'kneb';
    scope.style.cssText = 'position:static;inset:auto;display:block;opacity:1;width:' + CSSW + 'px;height:auto;background:#fff;z-index:auto;transition:none;';
    var clone = book.cloneNode(true);
    clone.hidden = false;
    clone.classList.add('kneb-pdf');
    var gate = clone.querySelector('.kneb-gate'); if (gate && gate.parentNode) gate.parentNode.removeChild(gate);
    scope.appendChild(clone);
    holder.appendChild(scope);
    document.body.appendChild(holder);

    try {
      await waitForImages(clone);
      await nextFrame();

      var pdf = new jsPDF({ unit: 'pt', format: 'a4', orientation: 'portrait', compress: true });
      var pageW = pdf.internal.pageSize.getWidth();
      var pageH = pdf.internal.pageSize.getHeight();

      var units = Array.prototype.slice.call(clone.querySelectorAll('.kneb-cover, .kneb-ch, .kneb-day'));
      if (!units.length) units = [clone];
      var y = 0, firstUnit = true;

      for (var i = 0; i < units.length; i++){
        if (onProgress) onProgress(Math.round((i / units.length) * 100));
        var el = units[i];
        var canvas;
        try {
          canvas = await h2c(el, { scale: SCALE, backgroundColor: '#ffffff', useCORS: true, allowTaint: false, logging: false, windowWidth: CSSW, width: CSSW });
        } catch (e) { continue; }
        if (!canvas || !canvas.height) continue;
        /* one bad section (e.g. a tainted cross-origin image) must never kill the whole PDF */
        try {
          var imgHpt = canvas.height * (pageW / canvas.width);
          var isCover = el.classList.contains('kneb-cover');

          if (isCover){
            if (!firstUnit) pdf.addPage();
            pdf.addImage(canvas.toDataURL('image/jpeg', 0.9), 'JPEG', 0, 0, pageW, pageH, undefined, 'FAST');
            y = pageH; firstUnit = false;
          } else if (imgHpt <= pageH){
            if (!firstUnit && (y + imgHpt) > pageH + 0.5){ pdf.addPage(); y = 0; }
            pdf.addImage(canvas.toDataURL('image/jpeg', 0.82), 'JPEG', 0, y, pageW, imgHpt, undefined, 'FAST');
            y += imgHpt; firstUnit = false;
          } else {
            /* section taller than one page → slice its (small) canvas across pages */
            if (!firstUnit) pdf.addPage();
            firstUnit = false; y = 0;
            var pxPerPt = canvas.width / pageW;
            var pageHpx = Math.floor(pageH * pxPerPt);
            var slice = document.createElement('canvas');
            var sctx = slice.getContext('2d');
            var sy = 0;
            while (sy < canvas.height){
              var hpx = Math.min(pageHpx, canvas.height - sy);
              slice.width = canvas.width; slice.height = hpx;
              sctx.fillStyle = '#ffffff'; sctx.fillRect(0, 0, canvas.width, hpx);
              sctx.drawImage(canvas, 0, sy, canvas.width, hpx, 0, 0, canvas.width, hpx);
              if (sy > 0) pdf.addPage();
              pdf.addImage(slice.toDataURL('image/jpeg', 0.82), 'JPEG', 0, 0, pageW, hpx / pxPerPt, undefined, 'FAST');
              sy += hpx; y = hpx / pxPerPt;
            }
          }
        } catch (e) { /* skip this section, keep building */ }
        canvas.width = canvas.height = 0; /* free memory between sections */
      }
      if (onProgress) onProgress(100);
      return pdf;
    } finally {
      if (holder.parentNode) holder.parentNode.removeChild(holder);
    }
  }

  /* ── instant download: pre-rendered PDF shipped as a theme asset ─────────────
     Crisp vector PDFs are rendered ahead of time and stored as tiny JS assets
     (each registers its base64 into window.__knebPdf). When a book has one,
     downloading is just "load asset → decode → save", i.e. instant, no on-device
     rendering. Books without a pre-rendered PDF fall back to the client build. */
  function base64ToBlob(b64, type){
    var bin = atob(b64), len = bin.length, bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: type });
  }
  function saveBlob(blob, filename){
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a'); a.href = url; a.download = filename;
    document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(url); if (a.parentNode) a.parentNode.removeChild(a); }, 6000);
  }
  /* Open the PDF in a NEW TAB (visitor can then view, save or share it). The tab is
     opened synchronously on the click gesture so it is not popup-blocked; we point it
     at the blob once the PDF is ready. If the tab was blocked, fall back to a direct
     download so the visitor still gets the file. */
  function openBlobInTab(blob, win, filename){
    var url = URL.createObjectURL(blob);
    var opened = false;
    if (win && !win.closed){ try { win.location.href = url; opened = true; } catch (e){ opened = false; } }
    if (!opened){
      var a = document.createElement('a'); a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.download = filename;
      document.body.appendChild(a); a.click();
      setTimeout(function(){ if (a.parentNode) a.parentNode.removeChild(a); }, 6000);
    }
    setTimeout(function(){ URL.revokeObjectURL(url); }, 60000); /* keep alive while the new tab loads it */
  }
  function loadPreRenderedPdf(id, cb){
    if (window.__knebPdf && window.__knebPdf[id]) return cb(window.__knebPdf[id]);
    var u = (window.KNEB_PDF_URLS || {})[id];
    if (!u) return cb(null);
    var s = document.createElement('script'); s.src = u;            /* load via a script element, no CORS */
    s.onload  = function(){ cb((window.__knebPdf && window.__knebPdf[id]) || null); };
    s.onerror = function(){ cb(null); };
    document.head.appendChild(s);
  }
  function clientBuild(book, name, win, setLabel, restore){
    setLabel('Bezig… 0%');
    buildBookPdf(book, function(p){ setLabel('Bezig… ' + p + '%'); }).then(function(pdf){
      try { openBlobInTab(pdf.output('blob'), win, name + '.pdf'); } catch (e){ saveBlob(pdf.output('blob'), name + '.pdf'); }
      restore();
    }).catch(function(){ if (win && !win.closed){ try { win.close(); } catch (e){} } restore(); try { window.print(); } catch (e) {} });
  }
  function downloadActiveBook(btn, noTab){
    var book = root.querySelector('.kneb-book:not([hidden])') || root.querySelector('.kneb-book');
    if (!book){ try { window.print(); } catch (e) {} return; }
    var id = book.getAttribute('data-kneb-book') || '';
    var name = (book.getAttribute('data-kneb-title') || 'ebook')
      .replace(/[·•]/g, '-').replace(/[^a-z0-9]+/gi, '-').replace(/^-+|-+$/g, '') || 'ebook';
    /* On a click we open a tab now (inside the gesture, so it is not popup-blocked) and
       point it at the blob once ready. On the e-mail deep-link path there is NO user
       gesture, so a popup tab can't be navigated to a blob (it hangs on the placeholder);
       pass noTab=true to force a direct <a download> save instead. */
    /* On mobile/touch, opening a new tab steals focus and backgrounds THIS tab,
       which throttles the html2canvas build so the placeholder tab hangs on
       "PDF wordt geopend…" forever. On touch devices build in the foreground and
       save directly (no popup tab); desktop keeps the open-in-new-tab UX. */
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (window.matchMedia && window.matchMedia('(pointer:coarse)').matches);
    var win = (noTab || isTouch) ? null : window.open('', '_blank');
    if (win){ try { win.document.write('<!doctype html><meta charset="utf8"><title>' + name + '<\/title><body style="margin:0;background:#0d1017;color:#9aa3ad;font:15px\/1.5 -apple-system,Segoe UI,Roboto,sans-serif;display:grid;place-items:center;height:100vh">PDF wordt geopend…<\/body>'); } catch (e){} }
    var orig = btn ? btn.innerHTML : '';
    var setLabel = function(t){ if (btn) btn.innerHTML = t; };
    if (btn){ btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = '.8'; }
    var restore = function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.style.pointerEvents = ''; btn.style.opacity = ''; btn.innerHTML = orig; } };
    /* ── Pre-rendered PDF hosted on the Shopify Files CDN ────────────────────────
       When a real CDN PDF exists for this book, link straight to it — no on-device
       jsPDF/html2canvas build, no base64 decode. Touch/no-gesture paths navigate the
       same tab (no blocked popup); desktop opens the already-opened tab or a download. */
    var cdn = (window.KNEB_PDF_URLS || {})[id];
    if (cdn){
      if (win && !win.closed){ try { win.location.href = cdn; } catch (e){ location.href = cdn; } }
      else if (noTab || isTouch){ location.href = cdn; }
      else {
        var la = document.createElement('a'); la.href = cdn; la.download = name + '.pdf'; la.rel = 'noopener'; la.target = '_blank';
        document.body.appendChild(la); la.click();
        setTimeout(function(){ if (la.parentNode) la.parentNode.removeChild(la); }, 6000);
      }
      restore();
      return;
    }
    setLabel('Even klaarzetten…');
    loadPreRenderedPdf(id, function(b64){
      if (b64){
        try { openBlobInTab(base64ToBlob(b64, 'application/pdf'), win, name + '.pdf'); restore(); return; }
        catch (e){ /* corrupt → fall through to client build */ }
      }
      clientBuild(book, name, win, setLabel, restore);
    });
  }
})();
